import { render, staticRenderFns } from "./SalesCapacityPriceSegment.vue?vue&type=template&id=71634c98&"
import script from "./SalesCapacityPriceSegment.vue?vue&type=script&lang=js&"
export * from "./SalesCapacityPriceSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports